module.exports = __webpack_public_path__ + "static/media/scifi.9eacc476.gif";